export default {
    props: {
        totalSlides: Number,
    },
    swiper: null,
    data: () => ({
        slidesPerView: 1,
    }),
    computed: {
        showNavigation() {
            return this.totalSlides > this.slidesPerView;
        },
        options() {
            return {
                slidesPerView: this.slidesPerView,
                loop: this.showNavigation,
                centerInsufficientSlides: !this.showNavigation,
                centeredSlides: this.showNavigation,
                preventInteractionOnTransition: true,
                allowSlidePrev: this.showNavigation,
                allowSlideNext: this.showNavigation,
                freeMode: !this.showNavigation,
                grabCursor: this.showNavigation,
                autoplay: !this.showNavigation ? false : {
                    delay: 8000,
                },
            };
        },
    },
    render() {
        return this.$scopedSlots.default({
            options: this.options,
            showNavigation: this.showNavigation,
            registerSwiper: this.registerSwiper,
            previous: this.previous,
            next: this.next,
        });
    },
    methods: {
        registerSwiper({ component }) {
            this.$options.swiper = component.swiper;
        },
        previous() {
            this.$options.swiper.slidePrev();
        },
        next() {
            this.$options.swiper.slideNext();
        },
    },
};
